import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import FlightFooterRow from "./FlightFooterRow";
import { useTranslation } from "react-i18next";
import { Divider, Space, Typography, Card } from "antd";
import {
  ArrowRightOutlined,
  ArrowLeftOutlined,
  SendOutlined,
} from "@ant-design/icons";

import "./FlightsFooter.scss";
import { useAppContext } from "../../contexts/AppContext";

const { Title } = Typography;

const FlightsFooter = ({ flight, flights }) => {
  const { isMobile } = useAppContext();
  const { t } = useTranslation();

  if (!flights && !flight) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="tw-text-center tw-p-8"
      >
        <Title level={4} className="tw-text-gray-500">
          שגיאה בטעינת נתוני הטיסות
        </Title>
      </motion.div>
    );
  }

  if (!flights) flights = flight;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4 },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="flights-footer-container tw-w-full"
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <AnimatePresence>
        {flights.map((flight, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="flight-group"
            style={{
              width: isMobile ? "100%" : "calc(50% - 8px)",
              minWidth: isMobile ? "100%" : "500px",
              maxWidth: "100%",
            }}
          >
            {Array.isArray(flight.leg) ? (
              flight.leg.map((leg, legIndex) => {
                const isOutbound = legIndex % 2 === 0;
                return (
                  <motion.div
                    key={legIndex}
                    initial={{ opacity: 0, x: isOutbound ? -30 : 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 0.5,
                      delay: legIndex * 0.1,
                    }}
                  >
                    <FlightFooterRow
                      flight={leg}
                      title={
                        isOutbound
                          ? t("packages.firstWayFlight")
                          : t("packages.returnFlight")
                      }
                    />
                  </motion.div>
                );
              })
            ) : (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
              >
                <FlightFooterRow
                  flight={flight.leg}
                  title={
                    index % 2 === 0
                      ? t("packages.firstWayFlight")
                      : t("packages.returnFlight")
                  }
                />
              </motion.div>
            )}
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

export default FlightsFooter;
